import { SyntheticEvent } from 'react';
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { CompanyEmployeeDto } from '@sr/dto';
import { ContactsPanel } from 'widgets/contacts/contact-panel';
import { EntitiesWithContacts } from 'features/contact/contacts.types';
import { formatPerson } from 'utils/person-format-helpers';
import { formatDate } from 'utils/date-format-helpers';

interface Props {
  personLink: CompanyEmployeeDto;
  onDelete: (link: CompanyEmployeeDto) => Promise<void>;
  companyId: number;
  canDelete: boolean;
}

export const PersonItem = ({ personLink, companyId, onDelete, canDelete }: Props) => {
  const { person, position, createdAt } = personLink;

  const personName = formatPerson(person);

  const handleDeletePersonClick = (e: SyntheticEvent) => {
    onDelete(personLink);
  };

  return (
    <Accordion >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}
      >
        <AccountBoxIcon color='disabled' sx={{ mr: 2 }} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) minmax(0, 1fr) auto' },
            alignItems: 'center',
            columnGap: 2,
            rowGap: 0.5,
            flexGrow: 1,
            minWidth: 0
          }}
        >
          <Typography noWrap>{personName}</Typography>
          <Typography noWrap sx={{ color: 'text.secondary' }}>{position}</Typography>
          <Typography noWrap variant='caption' sx={{ color: 'text.secondary', textAlign: { sm: 'right' } }}>
            Добавлен: {formatDate(createdAt)}
          </Typography>
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <ContactsPanel
          relationType={EntitiesWithContacts.person}
          relationId={person.id}
          dupesDisplayOptions={{ excludeLists: { company: [companyId], person: [person.id] } }} />
      </AccordionDetails>

      {canDelete && (
        <AccordionActions>
          <Button
            variant='text'
            color='error'
            size='small'
            onClick={handleDeletePersonClick}
          >
            Удалить сотрудника
          </Button>
        </AccordionActions>
      )}
    </Accordion>
  );
};
